<app-ai-welcome />

<div class="px-3 pt-3">
  <section class="ai-hero">
    <div class="ai-hero-content">
      <span class="ai-hero-eyebrow">
        <mat-icon>auto_awesome</mat-icon>
        {{ 'page.artificialIntelligence.hero.eyebrow' | translate }}
      </span>
      <h2 class="ai-hero-title">{{ 'page.artificialIntelligence.hero.title' | translate }}</h2>
      <p class="ai-hero-subtitle">{{ 'page.artificialIntelligence.hero.subtitle' | translate }}</p>
      <ul class="ai-hero-features">
        <li><mat-icon>lock</mat-icon>{{ 'page.artificialIntelligence.hero.featureSecure' | translate }}</li>
        <li><mat-icon>tune</mat-icon>{{ 'page.artificialIntelligence.hero.featureModels' | translate }}</li>
        <li><mat-icon>smart_toy</mat-icon>{{ 'page.artificialIntelligence.hero.featureAgents' | translate }}</li>
        <li>
          <mat-icon>verified_user</mat-icon>{{ 'page.artificialIntelligence.hero.featureOwnProvider' | translate }}
        </li>
      </ul>
    </div>
    <app-ai-illustration class="ai-hero-illustration" />
  </section>
</div>

<mat-tab-group animationDuration="0ms">
  <mat-tab label="{{ 'page.artificialIntelligence.providers' | translate }}">
    <div class="px-3 pt-3 pb-3">
      <app-ai-providers></app-ai-providers>
    </div>
  </mat-tab>
  <mat-tab label="{{ 'page.artificialIntelligence.agents' | translate }}">
    <!-- Lazy, so the agents tab reloads providers added on the first tab. -->
    <ng-template matTabContent>
      <div class="px-3 pt-3 pb-3">
        <app-ai-agents></app-ai-agents>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
